export const name = 'snowflake';

export const Snowflake = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      color="#161619"
    >
      <path
        d="M9.89781 25H14.1022L13.7518 15.4514L21.8978 20.5729L24 16.9271L15.4161 12.5L24 8.07292L21.8978 4.42708L13.7518 9.54861L14.1022 0H9.89781L10.2482 9.54861L2.10219 4.42708L0 8.07292L8.58394 12.5L0 16.9271L2.10219 20.5729L10.2482 15.4514L9.89781 25Z"
        fill="currentColor"
      />
    </svg>
  );
};
